import { TABLE } from './db';

export enum TOKEN {
    CLIENT = 'client',
    ACCOUNT = 'account',
    SECRET = 'secret',
    CHECKOUT = 'checkout',
    SUBSCRIPTION = 'subscription',
    INSTRUMENT = 'instrument',
    ADDRESS = 'address',
    MESSAGE = 'message',
    EVENT = 'event',
    CUSTOM_FLOW = 'custom_flow',
    FLOW_TEMPLATE = 'flow_template',
    CORE_FLOW_INSTANCE = 'core_flow_instance',
    CUSTOM_FLOW_INSTANCE = 'custom_flow_instance',
    FLOW_INSTANCE_GROUP = 'flow_instance_group',
    SHORT_TOKEN = 'short_token',
    INBOUND_KEYWORD = 'inbound_keyword',
    MERCHANT_FAQ = 'merchant_faq',
    SEGMENT = 'segment',
    TRIGGER = 'trigger',
    POPUP = 'popup',
    POPUP_TEMPLATE = 'popup_template',
    MEDIA_ASSET = 'media_asset',
    EXPERIMENT = 'experiment'
}

export const OLD_TOKEN_TO_NEW_TOKEN = {
    flow_instance:              TOKEN.CUSTOM_FLOW_INSTANCE,
    custom_flow_instance_group: TOKEN.FLOW_INSTANCE_GROUP
} as const;

export const TOKEN_TYPE_TO_TABLE = {
    [ TOKEN.CHECKOUT ]:            TABLE.CHECKOUT,
    [ TOKEN.SUBSCRIPTION ]:        TABLE.SUBSCRIPTION,
    [ TOKEN.INSTRUMENT ]:          TABLE.INSTRUMENT,
    [ TOKEN.ADDRESS ]:             TABLE.ADDRESS,
    [ TOKEN.MESSAGE ]:             TABLE.MESSAGE,
    [ TOKEN.ACCOUNT ]:             TABLE.ACCOUNT,
    [ TOKEN.CUSTOM_FLOW ]:         TABLE.CUSTOM_FLOW,
    [ TOKEN.FLOW_TEMPLATE ]:       TABLE.FLOW_TEMPLATE,
    [ TOKEN.FLOW_INSTANCE_GROUP ]: TABLE.FLOW_INSTANCE_GROUP,
    [ TOKEN.SHORT_TOKEN ]:         TABLE.SHORT_TOKEN,
    [ TOKEN.INBOUND_KEYWORD ]:     TABLE.INBOUND_KEYWORD,
    [ TOKEN.MERCHANT_FAQ ]:        TABLE.MERCHANT_FAQ,
    [ TOKEN.SEGMENT ]:             TABLE.SEGMENT,
    [ TOKEN.TRIGGER ]:             TABLE.TRIGGER,
    [ TOKEN.POPUP ]:               TABLE.POPUP,
    [ TOKEN.POPUP_TEMPLATE ]:      TABLE.POPUP_TEMPLATE,
    [ TOKEN.MEDIA_ASSET ]:         TABLE.MEDIA_ASSET,
    [ TOKEN.EXPERIMENT ]:          TABLE.EXPERIMENT
} as const;

export const TOKEN_TYPE_TO_ID = [
    TOKEN.CUSTOM_FLOW_INSTANCE,
    TOKEN.CORE_FLOW_INSTANCE
] as const;
